export enum ToasterEnum {
    maxOpened = 5
}